export const AUTH_LOG_IN_SUCCESS  = "auth/login/success";
export const AUTH_LOG_IN_ERROR  = "auth/login/error";
export const AUTH_LOG_OUT = "auth/logout";